import React, { useEffect, useState } from 'react';
import {
  Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle,
  FormControlLabel, Stack, Typography,
} from '@mui/material';

export interface PropositionFamille {
  key: string;
  label: string;     // ex : « Prix de vente »
  valeur: string;    // ex : « 500 (actuel : 450) »
}

interface FamilleDefautPropositionDialogProps {
  open: boolean;
  familleNom: string;
  propositions: PropositionFamille[];
  onClose: () => void;
  onAppliquer: (keys: string[]) => void;
}

/**
 * « Appliquer les valeurs de la famille ? » (migration 0136) — une case par valeur.
 * Rien n'est imposé : l'utilisateur coche ce qu'il reprend (tout coché par défaut).
 */
const FamilleDefautPropositionDialog: React.FC<FamilleDefautPropositionDialogProps> = ({
  open, familleNom, propositions, onClose, onAppliquer,
}) => {
  const [coches, setCoches] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (open) setCoches(new Set(propositions.map((p) => p.key)));
  }, [open, propositions]);

  const basculer = (key: string) =>
    setCoches((prev) => {
      const next = new Set(prev);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Appliquer les valeurs de la famille « {familleNom} » ?</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ color: '#667085', mb: 1.5 }}>
          Cochez les valeurs à reprendre dans l'article.
        </Typography>
        <Stack spacing={0.5}>
          {propositions.map((p) => (
            <FormControlLabel
              key={p.key}
              control={<Checkbox size="small" checked={coches.has(p.key)} onChange={() => basculer(p.key)} />}
              label={<Typography variant="body2"><strong>{p.label}</strong> : {p.valeur}</Typography>}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Ne rien appliquer</Button>
        <Button variant="contained" disabled={coches.size === 0} onClick={() => onAppliquer(Array.from(coches))}>
          Appliquer ({coches.size})
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FamilleDefautPropositionDialog;
